import styled from '@emotion/styled';

import theme from 'theme';
import {SizeTokenValue} from 'common';

import {CheckIcon, ErrorIcon, WarningOutlineIcon} from 'icons';

import {SnackbarVariant} from '../types';

import type {RequiredQA} from 'common';
import type {IconComponent} from 'icons';
import type {SnackbarContentProps} from '../types';

const variantIcon: Record<SnackbarVariant, IconComponent | null> = {
  [SnackbarVariant.Default]: null,
  [SnackbarVariant.Success]: CheckIcon,
  [SnackbarVariant.Warning]: WarningOutlineIcon,
  [SnackbarVariant.Error]: ErrorIcon,
};

const variantColor: Record<SnackbarVariant, string> = {
  [SnackbarVariant.Default]: theme.colors.white,
  [SnackbarVariant.Success]: theme.colors.additional.green[50],
  [SnackbarVariant.Warning]: theme.colors.additional.yellow[50],
  [SnackbarVariant.Error]: theme.colors.additional.red[50],
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-height: 32px;
  padding: 4px;
  box-sizing: border-box;

  ${theme.typography.h4}
`;

export const MessageIcon: React.FC<SnackbarContentProps & RequiredQA> = ({qa, message: {icon, variant}}) => {
  if (typeof icon !== 'undefined' && icon !== true) {
    return icon;
  }

  const Component = variantIcon[variant];
  if (!Component) {
    return null;
  }

  return (
    <Container data-qa={`${qa}-icon`}>
      <Component size={SizeTokenValue.Medium} color={variantColor[variant]} />
    </Container>
  );
};
